import { render, staticRenderFns } from "./VRTextArea.vue?vue&type=template&id=29f097eb"
import script from "./VRTextArea.vue?vue&type=script&lang=js"
export * from "./VRTextArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports